import {
LuSparkles,
LuMail,
LuMessageCircle,
LuContact
} from "react-icons/lu"
import { FaWhatsapp } from "react-icons/fa"
import { useState,useEffect } from "react"
import { useLocation } from "react-router-dom"
import "./Contact.css"

function Contact(){

const [loaded,setLoaded]=useState(false)
const location = useLocation()

useEffect(()=>{

window.scrollTo(0,0)

setLoaded(false)

const timer=setTimeout(()=>{
setLoaded(true)
},100)

return()=>clearTimeout(timer)

},[location.pathname])

return(

<section className={`contact-section ${loaded?"loaded":""}`}>

<h2>
<LuContact className="section-icon"/> Contact Developer
</h2>

<p className="contact-sub">
If you face any problem while using the platform, you can contact the developer directly.
</p>

<div className="contact-grid">

<div className="contact-card">

<FaWhatsapp className="contact-icon whatsapp"/>

<h3>WhatsApp Support</h3>

<p>
If you face any issue with the platform, contact the developer directly on WhatsApp.
</p>

<a
href="https://wa.me/919284024617"
target="_blank"
rel="noreferrer"
className="contact-btn whatsapp-btn"
>
<LuMessageCircle/> Chat on WhatsApp
</a>

</div>

<div className="contact-card">

<LuMail className="contact-icon gmail"/>

<h3>Email Support</h3>

<p>
You can also reach the developer via email for technical queries or suggestions.
</p>

<a
href="mailto:sanketpadhyal3@gmail.com"
className="contact-btn email-btn"
>
<LuMail/> Send Email
</a>

</div>

</div>

</section>

)

}

export default Contact